import { useInfiniteQuery } from 'react-query';
import {
  getRecommendBuddyList,
  type RecommendBuddyListResponse
} from '../../../findBuddy/services/findBuddyService';

type UseGetRecommendBuddyListParams = {
  perPage?: number;
};

const DEFAULT_PER_PAGE = 20;

export function useGetRecommendBuddyList(params: UseGetRecommendBuddyListParams = {}) {
  const { perPage = DEFAULT_PER_PAGE } = params;

  return useInfiniteQuery<RecommendBuddyListResponse>(
    ['recommendBuddyList', perPage],
    ({ pageParam = 1 }) => getRecommendBuddyList({ page: pageParam, perPage }),
    {
      getNextPageParam: (lastPage) => {
        const currentPage = lastPage?.meta?.pagination?.currentPage;
        const totalPages = lastPage?.meta?.pagination?.totalPages;

        if (typeof currentPage !== 'number' || typeof totalPages !== 'number') return undefined;
        if (currentPage < totalPages) return currentPage + 1;
        return undefined;
      },
      staleTime: 60 * 10 * 1000,
      cacheTime: 60 * 10 * 1000
    }
  );
}
